import React from "react";
import { motion } from "framer-motion";
import { Instagram as InstagramIcon, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { ASSETS, SOCIALS } from "../data";

const FEED = [
  ASSETS.headshotStudio,
  ASSETS.djBoothNight,
  ASSETS.beachSet,
  ASSETS.headshot,
  ASSETS.marinaSet,
  ASSETS.crowdLighting,
];

export const InstagramSection = () => (
  <section
    id="instagram"
    data-testid="instagram-section"
    className="relative py-24 md:py-40 bg-black overflow-hidden"
  >
    <div className="absolute -right-32 top-10 w-[420px] h-[420px] rounded-full bg-[#003399]/12 blur-[150px] pointer-events-none" />
    <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
        <div>
          <Reveal>
            <p className="text-[#003399] font-bold text-xs uppercase tracking-[0.3em] mb-6">
              The Feed
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display text-4xl md:text-6xl uppercase text-[#F2F2F2] leading-none">
              @taolumin
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <a
            data-testid="instagram-follow-btn"
            href={SOCIALS.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="self-start inline-flex items-center gap-2 px-6 py-3 bg-[#003399] text-[#F2F2F2] text-xs uppercase tracking-[0.2em] hover:shadow-[0_0_28px_rgba(0,51,153,0.8)] transition-shadow duration-300"
          >
            <InstagramIcon size={16} /> Follow
          </a>
        </Reveal>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
        {FEED.map((src, i) => (
          <Reveal key={i} delay={i * 0.06} className="group relative overflow-hidden">
            <a
              href={SOCIALS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`instagram-tile-${i}`}
              className="block relative overflow-hidden aspect-square"
            >
              <motion.img
                src={src}
                alt="TAO LUMIN on Instagram"
                initial={{ scale: 1.12 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-[#003399]/40 transition-colors duration-500 flex items-center justify-center">
                <InstagramIcon
                  size={30}
                  className="text-[#F2F2F2] opacity-0 scale-75 group-hover:opacity-100 group-hover:scale-100 transition-all duration-400"
                />
              </div>
            </a>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <a
          href={SOCIALS.instagram}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-10 inline-flex items-center gap-2 text-[#F2F2F2]/60 hover:text-[#F2F2F2] text-xs uppercase tracking-[0.25em] transition-colors duration-300"
        >
          See more on Instagram <ArrowUpRight size={15} />
        </a>
      </Reveal>
    </div>
  </section>
);

export default InstagramSection;
